import Button from "../../../shared/components/Button";
import type { Camera } from "../model";

export function CameraSettingsModal({
  camera,
  onClose,
}: {
  camera: Camera;
  onClose: () => void;
}) {
  return (
    <div
      aria-labelledby="camera-settings-title"
      aria-modal="true"
      className="dialog-backdrop"
      role="dialog"
    >
      <div className="dialog-panel">
        <div className="dialog-header">
          <div>
            <p className="eyebrow">Camera registry</p>
            <h2 id="camera-settings-title">Camera settings</h2>
            <p>{camera.location} · {camera.id}</p>
          </div>
          <Button aria-label="Close camera settings" className="close" onClick={onClose}>
            ×
          </Button>
        </div>
        <div className="settings-content">
          <div className="settings-grid">
            <div>
              <span>Status</span>
              <b>{camera.status}</b>
            </div>
            <div>
              <span>Source</span>
              <b>{camera.protocol ? `${camera.protocol.toUpperCase()} feed` : "Unknown protocol"}</b>
            </div>
          </div>
          <div className="endpoint">
            <span>Stream endpoint</span>
            <b>{camera.streamURL ?? "Not configured"}</b>
          </div>
          <p>Stream credentials remain stored by backend and are not shown here.</p>
          <Button fullWidth onClick={onClose} variant="secondary">Close</Button>
        </div>
      </div>
    </div>
  );
}
